import { ReactNode } from 'react';
import { Link } from '@mui/material';

// These tags are available
type Tag = 'link-terms';

type Props = {
  children(tags: Record<Tag, (chunks: ReactNode) => ReactNode>): ReactNode;
};

export default function RichI18n({ children }: Props) {
  return (
    <>
      {children({
        'link-terms': (chunks: ReactNode) => (
          <Link href={'/privacy-policy'} sx={{ textDecoration: 'underline' }}>
            {chunks}
          </Link>
        ),
      })}
    </>
  );
}
